<template>
  <v-app>
    <Header v-if="this.$route.path !== '/login'" />
    <Sidebar v-if="this.$route.path !== '/login'" />
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Header from "./components/organisms/Header";
import Sidebar from "./components/molecules/Sidebar";

export default {
  name: "App",
  components: { Header, Sidebar },
  data() {
    return {};
  },
};
</script>
